export default __webpack_public_path__ + "static/media/external-link-indeterminate.af1cc2bb.svg";